export const handleRateLimitError = (error, messageHandler) => {
  if (error?.status !== 429) {
    return false;
  }

  const { limit_left: limitLeft, reset_time: resetTime } =
    error?.response?.data || {};
  const hasLimit = limitLeft !== undefined && limitLeft > 0;

  let toastMessage = "Hourly limit reached!";
  if (resetTime && hasLimit) {
    toastMessage += ` You can add upto ${limitLeft} lead(s) until ${resetTime}`;
  } else if (resetTime) {
    toastMessage += ` No more leads can be added until ${resetTime}`;
  } else if (hasLimit) {
    toastMessage += ` You can add upto ${limitLeft} lead(s) per hour`;
  }

  messageHandler.error(toastMessage);
  console.error("Rate limit error: ", error);
  return true;
};

export const extractErrorMessage = (
  error,
  defaultMessage = "Something went wrong. Please try again later."
) => {
  const data = error?.response?.data;
  if (data?.error && typeof data.error === "string") {
    return data.error;
  }
  if (data?.message) {
    return data.message;
  }
  if (data?.errors) {
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      return data.errors[0];
    }
    if (typeof data.errors === "string") {
      return data.errors;
    }
  }
  return defaultMessage;
};

export const handleApiError = (
  error,
  messageHandler,
  fallbackHandler = null,
  defaultMessage = "Something went wrong. Please try again later."
) => {
  if (handleRateLimitError(error, messageHandler)) {
    return;
  }

  const errorMessage = extractErrorMessage(error, defaultMessage);

  if (fallbackHandler) {
    fallbackHandler(errorMessage);
  } else {
    messageHandler.error(errorMessage);
  }

  console.error("API error: ", error);
};

export const extractDetailedErrorMessage = (error, defaultMessage) => {
  // Handle both axios error objects (error.response.data) and direct response objects
  const errorData =
    error.response?.data || (error.success === false ? error : null);
  let errorMessage = defaultMessage;

  if (errorData) {
    // Check for single error field first
    if (errorData.error && typeof errorData.error === "string") {
      errorMessage = errorData.error;
    } else if (errorData.message) {
      errorMessage = errorData.message;
    } else if (errorData.results && Array.isArray(errorData.results)) {
      const allErrors = errorData.results
        .filter((result) => result.errors && result.errors.length > 0)
        .flatMap((result) => result.errors);

      if (allErrors.length > 0) {
        errorMessage = allErrors.join(", ");
      }
    } else if (errorData.errors) {
      // Handle errors field - can be array of strings or string
      if (Array.isArray(errorData.errors) && errorData.errors.length > 0) {
        errorMessage = errorData.errors[0];
      } else if (typeof errorData.errors === "string") {
        errorMessage = errorData.errors;
      }
    }
  } else if (error.message) {
    errorMessage = error.message;
  }

  return errorMessage;
};
